import type { LinkedAccountDisplay } from "../accountDisplay";
import { AccountStatusBadge } from "../AccountStatusBadge";
import { LinkedAccountRegionFlag } from "../LinkedAccountRegionFlag";
import { normalizeNameWithAt } from "@utils/util";
import { t } from "i18next";

interface LinkedAccountCardInfoProps {
  accountName?: string;
  expired: boolean;
  display: LinkedAccountDisplay;
  region?: string;
}

export const LinkedAccountCardInfo = ({ accountName, expired, display, region }: LinkedAccountCardInfoProps) => {
  return (
    <div className="flex min-w-0 flex-1 flex-col gap-[6px]">
      <div className="flex min-w-0 items-center gap-[4px] overflow-hidden">
        <p className="min-w-0 truncate text-[16px] font-normal leading-[24px] text-kds-fg">
          {normalizeNameWithAt(accountName)}
        </p>
        <AccountStatusBadge expired={expired} className="shrink-0" />
      </div>
      {display.subtitle ? (
        <div className="flex items-center gap-[4px]">
          <p className="whitespace-nowrap text-[14px] font-normal leading-[22px] text-kds-fg-soft">
            {t(display.subtitle)}
          </p>
          {display.showRegionFlag && region ? <LinkedAccountRegionFlag region={region} /> : null}
        </div>
      ) : display.showRegionFlag && region ? (
        <LinkedAccountRegionFlag region={region} />
      ) : null}
    </div>
  );
};
